import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { motion } from "framer-motion";

// Import your logos
import swanSolutionsLogo from "../../assets/logos/swansolutions_logo.png";
import swanAiLabsLogo from "../../assets/logos/swan_ai_labs_logo.png";

// Card data with descriptions
const buildFor = [
    {
        title: "Finance & Accounting",
        desc: "FIG Finance powers USDA-compliant financial management for K12 nutrition across 8+ districts. Procurement, spending, vendor management, and audit-ready reporting.",
    },
    {
        title: "Food & Nutrition",
        desc: "Hi5 for menu planning and nutrient analysis. LMS for staff training and certification compliance.",
    },
    {
        title: "Procurement & Audit",
        desc: "AI-powered bid analytics with Bid-FIG. Automated invoice review. SFR audit tools for compliance verification and documentation.",
    },
    {
        title: "CRM & Partnerships",
        desc: "District relationship management, partner onboarding, pipeline tracking, and coordinated outreach across your vendor network.",
    },
    {
        title: "AI & Analytics",
        desc: "Swan AI Labs delivers RAG solutions, custom chatbots, document AI, nutrient analysis, predictive analytics, and deep K12 visualization.",
    },
    {
        title: "Custom Software for EdTech & Vendors",
        desc: "Full-scale enterprise software, secure integrations, data pipelines, and custom platforms for districts and companies serving K12.",
    },
];

export default function WhatWeBuild() {
    return (
        <Box sx={{ bgcolor: "#f6f9fb", py: { xs: 8, md: 10 }, textAlign: "center" }}>
            <Typography
                variant="h3"
                sx={{ fontWeight: 800, mb: 1, fontSize: { xs: "2rem", md: "2.5rem" } }}
            >
                Software Built for K12
            </Typography>
            <Typography
                sx={{
                    color: "#25608a",
                    mb: 5,
                    fontSize: { xs: "1.08rem", md: "1.22rem" },
                    fontWeight: 400,
                }}
            >
                We design, develop, and support:
            </Typography>
            <Grid container spacing={4} justifyContent="center" alignItems="stretch">
                {buildFor.map((item, idx) => (
                    <Grid item xs={12} sm={10} md={6} key={item.title}>
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            whileHover={{ scale: 1.03, boxShadow: "0 4px 24px rgba(30,90,150,0.10)" }}
                            transition={{ duration: 0.4 + idx * 0.05 }}
                            viewport={{ once: true }}
                            style={{ height: "100%" }}
                        >
                            <Paper
                                elevation={0}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: 4,
                                    px: { xs: 2, sm: 3 },
                                    py: { xs: 2, sm: 2.5 },
                                    boxShadow: "0 2px 16px rgba(20,60,100,0.07)",
                                    minHeight: 110,
                                    bgcolor: "#fff",
                                    height: "100%",
                                    transition: "box-shadow 0.2s",
                                    gap: 2,
                                }}
                            >
                                {/* Swan Solutions logo left */}
                                <Box
                                    component="img"
                                    src={swanSolutionsLogo}
                                    alt="Swan Solutions"
                                    sx={{
                                        height: 48,
                                        width: 48,
                                        mr: 2,
                                        borderRadius: 1,
                                        boxShadow: "0 1px 4px 0 rgba(40,120,200,0.10)",
                                        bgcolor: "#e6f4f1",
                                        objectFit: "contain",
                                    }}
                                />
                                {/* Text */}
                                <Box sx={{ flex: 1, textAlign: "left" }}>
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontWeight: 700,
                                            color: "#043a5f",
                                            mb: 0.5,
                                            fontSize: { xs: "1.1rem", md: "1.18rem" },
                                        }}
                                    >
                                        {item.title}
                                    </Typography>
                                    <Typography sx={{ color: "#225174", fontSize: { xs: "1rem", md: "1.08rem" } }}>
                                        {item.desc}
                                    </Typography>
                                </Box>
                                {/* Swan AI Labs logo right */}
                                <Box
                                    component="img"
                                    src={swanAiLabsLogo}
                                    alt="Swan AI Labs"
                                    sx={{
                                        height: 40,
                                        width: 40,
                                        ml: 2,
                                        borderRadius: 1,
                                        bgcolor: "#e6f6f6",
                                        objectFit: "contain",
                                        boxShadow: "0 1px 3px 0 rgba(40,180,160,0.12)",
                                    }}
                                />
                            </Paper>
                        </motion.div>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}
